<template>
  <div id="paymentLink">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>场库二维码</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::">
              <el-select v-model="selCustID"
                         filterable
                         placeholder="请选择客户"
                         @change="setPark">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库名称::">
              <el-select v-model="selfParkID"
                         filterable
                         :clearable="true"
                         placeholder="请选择场库">
                <el-option v-for="item in choiceParks"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item label="">-->
            <!--<input type="checkbox" id="checkbox" v-model="codeChecked">-->
            <!--<label for="checkbox">扩展二维码(客户分组场内预付码、月卡续费等码)</label>-->
            <!--</el-form-item>-->
            <el-form-item label="">
              <el-switch v-model="codeChecked" />
              <label>扩展二维码(客户分组场内预付码、月卡续费、商户等码)</label>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="initData">生成二维码</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  class="searchRowAdd">
            <el-button type="primary"
                       size="small"
                       class="copyAllbtn"
                       :data-clipboard-text='copyText'
                       @click="copyAll">复制全部</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column prop="index"
                         width="50"
                         label="序号">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         width="80"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fParkNo"
                         width="80"
                         label="场库编号">
        </el-table-column>
        <el-table-column prop="fParkName"
                         width="150"
                         label="场库名称">
        </el-table-column>
        <el-table-column prop="fChnlNo"
                         width="80"
                         label="通道编号">
        </el-table-column>
        <el-table-column prop="fChnlName"
                         width="150"
                         label="通道名称">
        </el-table-column>
        <el-table-column prop="ChnlTypeName"
                         width="100"
                         label="通道类型">
        </el-table-column>
        <el-table-column prop="fLinkType"
                         width="200"
                         label="二维码类型">
        </el-table-column>
        <el-table-column prop="fLinkUrl"
                         label="二维码连接">
          <!-- <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content"
                   v-html="scope.row.fLinkUrl"></div>
              <span>{{scope.row.fLinkUrl}}</span>
            </el-tooltip>
          </template> -->
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         align="center"
                         width="180">
          <template slot-scope="scope">
            <el-button v-if="scope.row.fIsUrl"
                       @click="showDialog(scope.row)"
                       type="primary"
                       size="mini">查看</el-button>
            <el-button :data-clipboard-text="scope.row.fLinkUrl"
                       @click="copy"
                       type="success"
                       class="copybtn"
                       size="mini">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog class="qCodeDialog"
               :title="dialogTitle"
               :visible.sync="qCodeDialogVisible"
               v-dialogDrag
               top="7vh"
               left="0vh"
               width="500px">
      <template>
        <el-row>
          <el-col :span="24"
                  align="center">
            <img :src="'data:image/png;base64,'+ imgBase64"
                 width="305"
                 height="345"
                 id="imgDown">
          </el-col>
        </el-row>
      </template>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="qCodeDialogVisible = false">关 闭</el-button>
        <el-button @click="downloadImg"
                   icon="el-icon-takeaway-box"
                   type="success"
                   size="medium">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Clipboard from 'clipboard'
import * as park from '../../api/park'
export default {
  name: 'channelMain.vue',
  data () {
    return {
      qCodeDialogVisible: false,
      imgBase64: '',
      dialogTitle: '',
      tableHeight: 0,
      selCustID: '',
      selfParkID: '',
      codeChecked: false,
      tableData: [],
      choiceParks: [],
      choiceCusts: [],
      copyText: '',
      loading: false
    }
  },
  methods: {
    ...mapActions([
      'getCurrentUserPers'
    ]),
    downloadImg () {
      var d = document.getElementById('imgDown')
      var url = d.src
      var a = document.createElement('a')
      var event = new MouseEvent('click')
      a.download = 'QCode' + new Date().getSeconds() + '.png'
      a.href = url
      a.dispatchEvent(event)
    },
    showDialog (row) {
      this.dialogTitle = row.fParkName + '-' + row.fLinkType
      park.createQcodeImg({ 'fParkName': row.fParkName, 'fChnlName': row.fChnlName, 'fLinkType': row.fLinkType, 'fLinkUrl': row.fLinkUrl }).then(res => {
        let { status, data } = res
        if (status !== 200) {
          this.$message.error('提示：生成二维码出错')
        } else {
          if (!data.IsOk) {
            this.$message.error(data.Msg)
          } else {
            if (data.Data) {
              this.qCodeDialogVisible = true
              this.imgBase64 = data.Data
            }
          }
        }
      })
    },
    initData () {
      if ((this.selCustID || '').length > 0) {
        this.loading = true
        park.getParkPayLink({ fCustID: this.selCustID, fParkID: this.selfParkID, codeChecked: this.codeChecked }).then(res => {
          this.loading = false
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.tableData = data.Data || []
                this.copyText = ''
                for (var i = 0; i < this.tableData.length; i++) {
                  if ((this.tableData[i].fChnlName || '').length > 0) {
                    this.copyText += '[' + this.tableData[i].fParkNo + ']' + this.tableData[i].fParkName + ' [' + this.tableData[i].fChnlNo + ']' + this.tableData[i].fChnlName + ' ' + this.tableData[i].fLinkType + '链接 \r\n' + this.tableData[i].fLinkUrl + '\r\n\r\n'
                  } else {
                    this.copyText += '[' + this.tableData[i].fParkNo + ']' + this.tableData[i].fParkName + ' ' + this.tableData[i].fLinkType + '链接 \r\n' + this.tableData[i].fLinkUrl + '\r\n\r\n'
                  }
                }
              }
            }
          }
        })
      }
    },
    copy () {
      var clipboard = new Clipboard('.copybtn')
      clipboard.on('success', e => {
        this.$message({
          message: '提示：复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message({
          message: '提示：该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    copyAll () {
      var clipboard = new Clipboard('.copyAllbtn')
      clipboard.on('success', e => {
        this.$message({
          message: '提示：复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message({
          message: '提示：该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    setPark (val) {
      this.choiceParks = []
      this.selfParkID = ''
      park.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.choiceParks = data.Data || []
              // if (this.choiceParks.length > 0) {
              //   this.selfParkID = this.choiceParks[0].fParkID
              // }
            }
          }
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 180
      obj.tableHeight = clientHeight
    }
  },
  created () {
    // this.getCurrentUserPers({ perTypeId: 22000 }).then(res => {
    //   if (res && res.data) {
    //     var data = res.data
    //     if (data.IsOk) {
    //       if (data.Data) {
    //         this.is_edit = data.Data.data.is_edit
    //         this.is_del = data.Data.data.is_del
    //         this.is_syn = data.Data.data.is_syn
    //       }
    //     } else {
    //       this.$message.error('提示：加载当前用户权限信息失败')
    //     }
    //   }
    // })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style >
.qCodeDialog .el-dialog__title {
  color: white;
}
.qCodeDialog .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.qCodeDialog .el-dialog__headerbtn {
  top: 15px;
}
</style>
<style scoped>
fieldset {
  padding-bottom: 0px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.el-form-item {
  margin-bottom: 0px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}

.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/park/paymentLink.vue